<template>
  <div class="section_wrap">
    <div class="head">
      <!-- <div class="head-left"></div> -->
      <div class="head-center">
        <div class="title">
          <div class="title-text">历史资源</div>
        </div>
      </div>
      <div class="head-right"></div>
    </div>
    <div class="body">
      <div class="showcase">
        <template v-if="listData.length">
          <div class="goods-list">
            <div class="goods-item" v-for="(item, index) in listData" :key="index">
              <div class="goods-item-img">
                <template>
                  <div class="goods-img" @click="toDetail(item)">
                    <el-image class="image" :src="item.cover" @error="handleError" />
                  </div>
                </template>
              </div>
              <div class="goods-item-info">
                <div class="title ellipsis">{{ item.title }}</div>
                <div class="content">
                  <img class="icon" src="@/assets/home/like.png" alt />
                  <span class="txt">{{ item.likes_count }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="elpagination">
            <div class="elpagination-title">共{{ total }}条</div>
            <el-pagination
              background
              layout="prev, pager, next, jumper"
              prev-text="上一页"
              next-text="下一页"
              :total="total"
              :current-page="queryParams.page"
              :page-size="queryParams.per_page"
              @current-change="pageChange"
            ></el-pagination>
          </div>
        </template>
        <template v-else>
          <el-empty :image-size="110" class="el-empty--cont"></el-empty>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getRecordLiveList } from "@/api/live.js"
export default {
  name: "liveHistory",
  components: {},
  data () {
    return {
      queryParams: {
        sn: "",
        keyword: "",
        per_page: 10,
        page: 1,
      },
      total: 0,
      loading: false,
      listData: [],
      goodsimage: require("@/assets/default/image02.jpg"),
    }
  },
  computed: {},
  created () {
    this.getList()
  },
  mounted () { },
  methods: {
    handleError (e) {
      // 当图片加载失败时，将图片地址设置为默认图片
      e.target.src = this.goodsimage
      // 可以添加额外的处理，比如提示用户或者进行日志记录
    },
    getList () {
      this.loading = true
      getRecordLiveList(this.queryParams).then((res) => {
        this.loading = false
        if (res.code === 0) {
          this.listData = res.data?.data ?? []
          this.total = res.data?.total ?? 0
        }
      }).catch(() => { })
    },
    //页码发生改变时
    pageChange (val) {
      this.queryParams.page = val
      this.getList()
    },
    toDetail (item) {
      window.localStorage.setItem("menuId", 4)
      this.$store.dispatch("setmenuid", 4)
      this.$router.push({
        path: "/move",
        query: {
          sn: item.sn,
        },
      })
    },
  },
};
</script>
<style scoped lang="scss">
.section_wrap {
  width: 100%;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 40px;
    margin-bottom: 20px;
    .head-left {
      width: 64px;
    }
    .head-center {
      // flex: 1;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        .title-icon {
          width: 32px;
          height: 32px;
          margin-left: 10px;
          .elimage {
            width: 100%;
            height: 100%;
          }
        }
        .title-text {
          color: #000;
          font-size: 30px;
          font-weight: bold;
          line-height: 40px;
        }
      }
    }
    .head-right {
      .more {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 40px;
        margin-left: 15px;
        .elimage {
          width: 38px;
          height: 38px;
        }
      }
    }
  }
  .body {
    .showcase {
      .goods-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        .goods-item {
          width: calc((100% - 80px) / 5);
          height: 326px;
          background-color: #fff;
          border-radius: 5px;
          margin-left: 20px;
          overflow: hidden;
          cursor: pointer;
          .goods-item-img {
            position: relative;
            height: calc(100% - 90px);
            .goods-img {
              width: 100%;
              height: 100%;
              background: aliceblue;
              .image {
                display: inline-block;
                -webkit-transition-duration: 0.3s;
                transition-duration: 0.3s;
                -webkit-transition-property: transform;
                transition-property: transform;
                -webkit-transform: translateZ(0);
                transform: translateZ(0);
                box-shadow: 0 0 1px rgba(0, 0, 0, 0);
              }

              .image:hover,
              .image:focus,
              .image:active {
                -webkit-transform: scale(1.1);
                transform: scale(1.1);
              }

              .image {
                width: 100%;
                height: 100%;
              }
            }
          }
          .goods-item-info {
            height: 90px;
            padding: 20px 10px;
            background: #ffffff;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .title {
              font-weight: bold;
              font-size: 18px;
              color: #333333;
            }
            .content {
              display: flex;
              align-items: center;
              .txt {
                color: #999;
                font-size: 12px;
                font-weight: 400;
              }
              .icon {
                width: 18px;
                height: 18px;
                margin-right: 5px;
              }
            }
          }
        }
        .goods-item:nth-child(n + 6) {
          margin-top: 20px;
        }
        .goods-item:nth-child(5n + 1) {
          margin-left: 0px;
        }
      }
      .elpagination {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 20px;
        .elpagination-title {
          margin-right: 10px;
        }
      }
      .el-empty--cont {
        padding: 0px;
        min-height: 280px;
      }
    }
  }
}

@media screen and (max-width: 640px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-icon {
            width: 18x;
            height: 18px;
          }
          .title-text {
            font-size: 18px;
          }
        }
      }
      .head-right {
        .more {
          margin-left: 5px;
          .elimage {
            width: 20px;
            height: 20px;
          }
        }
      }
    }
    .body {
      .showcase {
        margin: 0;
        .goods-list {
          .goods-item {
            width: calc((100% - 25px) / 2);
          }
        }
      }
    }
  }
}
@media screen and (min-width: 640px) and (max-width: 1200px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-icon {
            width: 24px;
            height: 24px;
          }
          .title-text {
            font-size: 24px;
          }
        }
      }
      .head-right {
        .more {
          margin-left: 10px;
          .elimage {
            width: 26px;
            height: 26px;
          }
        }
      }
    }
    .body {
      .showcase {
        .goods-list {
          justify-content: flex-start;
          .goods-item {
            width: calc((100% - 40px) / 4);
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .section_wrap {
    .head {
      .head-center {
        .title {
          .title-icon {
            width: 32px;
            height: 32px;
          }
          .title-text {
            font-size: 30px;
          }
        }
      }
      .head-right {
        .more {
          .elimage {
            width: 38px;
            height: 38px;
          }
        }
      }
    }
  }
}
</style>
